export const attendee = {
    search: (roomSlug: string, query?: string): string =>
        `/rooms/${roomSlug}/search/${query ? encodeURIComponent(query) : ''}`
};

export const admin = {
    search: (roomSlug: string, query?: string): string =>
        `/administrator/rooms/${roomSlug}/search/${query ? encodeURIComponent(query) : ''}`
};

export const api = {
    search: (roomSlug: string): string => `/api/rooms/${roomSlug}/search`,
    searchDocuments: (meetingId: string): string => `/api/events/${meetingId}/documents/search/`
};
